import React from 'react';
import { FinalState, TableProps } from 'react-table';
import classnames from 'classnames';

import Button from '@components/Button';

import './style.scss';

export interface IOwnProps {
  paginationSummary: React.ReactNode;
  total?: number;
}

interface ITablePaginationProps extends TableProps, FinalState, IOwnProps {}

interface ITablePaginationState {
  page: number;
  total: number;
}

export default class TablePagination extends React.Component<ITablePaginationProps, ITablePaginationState> {
  static defaultProps: Partial<ITablePaginationProps> = {
    className: '',
    pages: null,
    page: 0,
    onPageChange: () => null,
  };

  constructor(props: ITablePaginationProps) {
    super(props);

    this.state = {
      page: this.props.page,
      total: 0,
    };
  }

  componentDidUpdate(prevProps: Readonly<ITablePaginationProps>) {
    const nextProps = this.props;
    const newState = {} as ITablePaginationState;

    if (nextProps.total !== prevProps.total) {
      newState.total = nextProps.total;
    }
    if (nextProps.page !== prevProps.page) {
      newState.page = nextProps.page;
    }

    if (Object.keys(newState).length) {
      this.setState(newState);
    }
  }

  getSafePage = (xpage) => {
    let page = xpage;
    if (isNaN(xpage)) {
      page = this.props.page;
    }

    return isNaN(xpage) ? xpage : Math.min(Math.max(page, 0), this.props.pages - 1);
  };

  changePage = (xpage) => {
    const page = this.getSafePage(xpage);
    this.setState({ page });
    if (this.props.page !== page) {
      this.props.onPageChange(page);
    }
  };

  applyPage = (e: any) => {
    if (e) {
      e.preventDefault();
    }

    this.changePage(!isNaN(this.state.page) ? this.state.page : 0);
  };

  render() {
    const { pages, page, showPageJump, canPrevious, canNext, className, paginationSummary } = this.props;

    return (
      <div className={classnames('table__pagination', 'flex-row--center')}>
        {paginationSummary}
        <div className={`${className} table__pagination-controls`} style={this.props.style}>
          <div className="table__pagination-page-nos">
            {showPageJump ? (
              <div>
                <input
                  type="text"
                  aria-label="Page number"
                  onChange={(e) => {
                    const val = parseInt(e.target.value, 10);
                    const xpage = val - 1;
                    this.setState({ page: this.getSafePage(xpage) });
                  }}
                  value={isNaN(this.state.page) ? '' : !pages ? 1 : Math.max(1, this.state.page + 1)}
                  onBlur={this.applyPage}
                  onKeyPress={(e) => {
                    if (e.which === 13 || e.keyCode === 13) {
                      this.applyPage(null);
                    }
                  }}
                />
              </div>
            ) : (
              <span>{!pages ? 1 : Math.max(1, page + 1)}</span>
            )}
            <span className="table__pagination-of-text">{`${this.props.ofText || 'of'} ${pages || 1}`}</span>
          </div>
          <div className="table__pagination-nav-btns">
            <Button
              bsStyle={ButtonStyle.DEFAULT}
              aria-label="Previous page"
              onClick={() => {
                if (!canPrevious || !pages) {
                  return;
                }
                this.changePage(page - 1);
              }}
              disabled={!canPrevious || !pages}
            />
            <Button
              bsStyle={ButtonStyle.DEFAULT}
              aria-label="Next page"
              onClick={() => {
                if (!canNext || !pages) {
                  return;
                }
                this.changePage(page + 1);
              }}
              disabled={!canNext || !pages}
            />
          </div>
        </div>
      </div>
    );
  }
}
